
// 正则
export const Exp = {
    // 帐号
    account:/^\w{6,16}$/,
    // 密码
    password:/^(?!^\d+$)(?!^[a-zA-Z]+$)(?!^[\~\`\!\@\#\$\%\^\&\*\(\)\-\+\=\{\[\}\]\|\\\:\;\”\’\<\,\>\.\?\/]+$)[\w\~\`\!\@\#\$\%\^\&\*\(\)\-\+\=\{\[\}\]\|\\\:\;\”\’\<\,\>\.\?\/]{8,16}$/,
    // 旧密码
    oldpassword:/^[\w\~\`\!\@\#\$\%\^\&\*\(\)\-\+\=\{\[\}\]\|\\\:\;\”\’\<\,\>\.\?\/]{6,16}$/,
    // 邮箱
    email:/^((?=[a-zA-Z0-9])[a-zA-Z0-9._-]+)?[a-zA-Z0-9]{1}@[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)?(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,}){1}$/,
    // 郵箱或用戶名
    account_email:/^(\w{6,16}|(((?=[a-zA-Z0-9])[a-zA-Z0-9._-]+)?[a-zA-Z0-9]{1}@[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)?(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,}){1}))$/,
    // 驗證碼
    code:/^[a-zA-Z0-9]{4}$/,
    // 整型
    int:/^\d+$/,
    // 域名
    domainName:/^[a-zA-Z0-9]+(-?[a-zA-Z0-9]+)?(\.[a-zA-Z]{2,}){1,2}$/
}

// 格式化
export const Format={
    // 科學計數法轉數字
    enum:r=>{
      let str = r.toString().split('e-');
      if (str.length < 2) return r.toString();
      r = '0.';
      for (let i = 1; i < Number(str[1]); i++) r += '0';
      return r + str[0].replace('.', '');
    },
    // 进一法取小数金额
    money:n=>{
      if(n==''||isNaN(n)) return 0;
      return Math.ceil(n*100)/100;
    },
    // 限制小数位数
    toFixed:(v,n)=>{
      if(isNaN(v)) return '';
      v=v.toString();
      if(v.indexOf('.')==-1) v+='.';
      v=v.split('.');
      if(v[1].length>n){
        v[1]=v[1].substring(0,n);
      }else{
        while(v[1].length<n){
          v[1]+='0';
        }
      }
      return v.join('.');
    },
     // 获取小数后几位
    decimal:(num,len) => {
        let numStr = num.toString();
            if (len == null || len == undefined) {
                len = numStr.length;
            }
            let index = numStr.indexOf('.');
            if (index == -1) {
                index = numStr.length;
                numStr += ".0000000000000";
            } else{
                numStr += "0000000000000";
            }
            let newNum = numStr.substring(0, index + len + 1);
            return newNum;
    },
    // 添加千位符
    thousand:s=>{
        if(isNaN(s)) return '';
        s=s.toString();
        s=s.replace(/^(\d*)$/,"$1.");  
        s=(s+"00").replace(/(\d*\.\d\d)\d*/,"$1");  
        s=s.replace(".",",");  
        var re=/(\d)(\d{3},)/;  
        while(re.test(s)){  
        s=s.replace(re,"$1,$2");  
        }  
        s=s.replace(/,(\d\d)$/,".$1");  
        return s.replace(/^\./,"0.")  
    },
    // 转为时间戳
    timestamp:dt=>{
        if (/^\d{4}(\-\d{1,2}){2}\ \d{2}(\:\d{2}){2}$/.test(dt)){
        dt = dt.split(/[- : \/]/);
        dt = new Date(dt[0], dt[1] - 1, dt[2], dt[3], dt[4], dt[5]).getTime();
        }
        return dt;
    },
}

// 金额格式
export const Money=s=>{
    if(isNaN(s)) return '';
    s=s.toString();
    s=s.replace(/^(\d*)$/,"$1.");  
    s=(s+"00").replace(/(\d*\.\d\d)\d*/,"$1");  
    s=s.replace(".",",");  
    let re=/(\d)(\d{3},)/;  
    while(re.test(s)){  
      s=s.replace(re,"$1,$2");  
    }  
    s=s.replace(/,(\d\d)$/,".$1");  
    return s.replace(/^\./,"0.");
  }

  //storage
export const storage = {
    set (key,value) {
      sessionStorage.setItem(key, JSON.stringify(value))
    },
    get (key) {
      return JSON.parse(sessionStorage.getItem(key))
    },
    clear () {
      return sessionStorage.clear()
    }
  }

  /**
 * 
 * @desc   现金额转大写
 * @param  {Number} n 
 * @return {String}
 */
export const digitUppercase=(n)=>{
  if(isNaN(n)||n=='') return '';
  var fraction = ['角', '分'];
  var digit = [
      '零', '壹', '贰', '叁', '肆',
      '伍', '陆', '柒', '捌', '玖'
  ];
  var unit = [
      ['元', '万', '亿'],
      ['', '拾', '佰', '仟']
  ];
  var head = n < 0 ? '欠' : '';
  n = Math.abs(n);
  var s = '';
  for (var i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  n = Math.floor(n);
  for (var i = 0; i < unit[0].length && n > 0; i++) {
      var p = '';
      for (var j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return head + s.replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整');
};